import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import globalStyles from "../../../Styles/global.module.scss"
import styles from "../../../Styles/ComponentStyles/MainPages/Usergroup.module.scss"
import memberStyles from "../../../Styles/ComponentStyles/MainPages/Member.module.scss"

import Grid from '@mui/material/Grid2';
import AddIcon from '@mui/icons-material/Add';
import deleteIcon from "../../../Assets/Member/Delete-Icons.svg"

import { DataGrid } from '@mui/x-data-grid';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';

import { MemberContext, MemberContextPayload } from '../../../Context/MemberDetailsContext';
import { GlobalUserContext, GlobalUserContextPayload } from '../../../Context/GlobalUserDetailContext';
import agent from '../../../Services/api';

import { useSnackbar } from '../../../Utils/Layout/GlobalSnackbar/GlobalSnackbar';
import GlobalButton from '../../../Utils/Layout/GlobalButton/GlobalButton';
import GlobalDialog from '../../../Utils/Layout/GlobalDialog/GlobalDialog';
import GlobalWarningDialog from '../../../Utils/Layout/GlobalWarningDialog/GlobalWarningDialog';


const UserGroup = () => {

    const {
        userGroupListDetails,
        setUserGroupListDetails,

        storedGroupDetails,
        setStoredGroupDetails,

        setExitingUserGroupDetails,
        existingUserGroupDetails
    } = useContext(MemberContext) as MemberContextPayload

    const {
        setFlagLoader,
    } = useContext(GlobalUserContext) as GlobalUserContextPayload

    const { showSnackbar } = useSnackbar();
    const navigate = useNavigate();

    const [flagDeleteRowDialog, setFlagDeleteRowDialog] = useState(false)
    // const [flagOpenUsergroupDialog, setFlagOpenUsergroupDialog] = useState(false)

    const columns: any = [
        {
            field: 'groupName',
            headerName: 'GROUP NAME',
            flex: 1,
            width: 250,
            minWidth: 250,
            maxWidth: 250,
        },
        {
            field: 'activeUserCount',
            headerName: '#ACTIVE USER',
            flex: 1,
            minWidth: 200,
            maxWidth: 200,
        },
        {
            field: 'action',
            headerName: '',
            minWidth: 150,
            flex: 1,
            align: "right",
            headerAlign: "right",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params: any) => {
                const groupID = Number(params.row?.groupId)
                const groupname = params.row?.groupName
                const userCount = params.row?.activeUserCount
                const isDefaultGroup = params.row?.isDefaultGroup;
                return (
                    <>
                        {!isDefaultGroup && (
                            <IconButton
                                onClick={(e) => {
                                    e.stopPropagation()
                                    setFlagDeleteRowDialog(true)
                                    setStoredGroupDetails({
                                        groupId: groupID,
                                        groupName: groupname,
                                        userCount: userCount
                                    })
                                    setExitingUserGroupDetails({ ...existingUserGroupDetails, groupName: groupname })
                                }}
                            >
                                <Tooltip
                                    title="Delete"
                                    arrow
                                    placement="bottom"
                                    componentsProps={{
                                        tooltip: { className: globalStyles.globalTooltipStyle },
                                        arrow: { className: globalStyles.globalTooltipArrowStyle },
                                    }}
                                >
                                    <img src={deleteIcon} alt="" style={{ width: '30px', height: '30px' }} />
                                </Tooltip>
                            </IconButton>
                        )}
                    </>
                )
            }
        }

    ]

    useEffect(() => {
        fetchUserGroupData()
    }, [])

    const fetchUserGroupData = async () => {
        setFlagLoader(true)
        const response = await agent.getGroupDetailsByGroupApi.get()
        if (response?.status) {
            console.log("response of getUserGroupsApi", response);
            const responseData = response?.data
            setUserGroupListDetails(responseData)
            setFlagLoader(false)
        }
        else {
            const errorMessage = response?.error?.message || 'Something Went Wrong!';
            showSnackbar(errorMessage, 'error');
            setFlagLoader(false);
        }
    }

    const NoDataOverlay = () => (
        <Box
            sx={{
                textAlign: 'center',
                width: '100%',
                marginTop: '40px',
                color: '#ccc',
            }}
        >
            <Typography variant="body1" sx={{ fontWeight: 500 }}>
                No Data Found
            </Typography>
        </Box>
    );

    const handleCellClick = (params: any) => {
        const groupId = Number(params?.row?.groupId);
        if (groupId) {
            setStoredGroupDetails({
                ...storedGroupDetails,
                groupId: groupId
            })
            navigate(`/member/viewUserGroup?groupId=${groupId}`);
        }
    };

    const handleDeleteRow = async () => {
        if (!storedGroupDetails) return

        const payload = {
            groupId: Number(storedGroupDetails?.groupId)
        }

        setFlagLoader(true);
        const response = await agent.deleteGroupAppApi.delete(payload)
        console.log("response of deleteGroupAppApi", response);
        if (response?.status) {
            const message = response?.message || "User deleted successfully!";
            showSnackbar(message, "success");
            await fetchUserGroupData()
            setFlagLoader(false);
            setFlagDeleteRowDialog(false)
        }
        else {
            const errorMessage = response?.error?.message || 'Something Went Wrong!';
            showSnackbar(errorMessage, 'error');
            setFlagLoader(false);
            setFlagDeleteRowDialog(false)
        }
    }

    return (
        <>

            {/* {flagOpenUsergroupDialog && (
                <GlobalDialog
                    open={flagOpenUsergroupDialog}
                    flagHeadSection={true}
                    maxWidth="sm"
                    dialogHead="Add New Group"
                    view={
                        <UserGroupAdditionDialog />
                    }
                    onClose={() => { setFlagOpenUsergroupDialog(false) }}
                />
            )} */}

            {flagDeleteRowDialog &&
                <GlobalDialog
                    flagHeadSection={true}
                    open={flagDeleteRowDialog}
                    maxWidth="sm"
                    dialogHead={'Delete Confirmation'}
                    onClose={() => setFlagDeleteRowDialog(false)}
                    view={
                        <GlobalWarningDialog
                            // popupDescription={`Are you sure you want to delete ${existingUserGroupDetails?.groupName}?`}
                            popupDescription={`Group ${storedGroupDetails?.groupName} has ${storedGroupDetails?.userCount} users. They will be moved to the Default Group. Do you want to proceed?`}
                            primaryButtonText={"Delete"}
                            secondaryButtonText={"Cancel"}
                            primaryButtonWidth="175px"
                            secondaryButtonWidth="175px"
                            onDelete={handleDeleteRow}
                            handleClose={() => setFlagDeleteRowDialog(false)}
                        />
                    }
                />
            }


            <Grid container>
                <Grid size={{ xs: 12 }} className={`${styles.userGroupTableMainItem}`}>
                    <Grid container>
                        <Grid size={{ xs: 12 }} sx={{ textAlign: 'left', m: "15px 0px 15px" }}>
                            <GlobalButton
                                variant='contained'
                                value='New Group'
                                startIcon={<AddIcon sx={{ color: 'white' }} />}
                                className={styles.addOutlinedBtn}
                                onClick={() => {
                                    navigate("/member/viewUserGroup")
                                    // setFlagOpenUsergroupDialog(true) 
                                }}
                            />
                        </Grid>
                        <Grid size={{ xs: 12 }} sx={{ margin: "5px 0px 0px", height: "calc(100vh - 260px)" }}>
                            <DataGrid
                                rows={userGroupListDetails?.groups ?? []}
                                columns={columns}
                                getRowId={(row) => row.groupId}
                                className={`${globalStyles.globalDatagridStyles} ${memberStyles.userTableStyles}`}
                                checkboxSelection={false}
                                disableRowSelectionOnClick
                                rowHeight={50}
                                columnHeaderHeight={50}
                                hideFooter
                                hideFooterPagination
                                hideFooterSelectedRowCount
                                rowSelection={false}
                                onCellClick={handleCellClick}
                                // pagination
                                // pageSizeOptions={[10, 20, 30]}
                                // rowCount={userGroupListDetails?.groups?.length}
                                // initialState={{
                                //     pagination: {
                                //         paginationModel: { pageSize: 20, page: 0 }
                                //     }
                                // }}
                                slots={{
                                    noRowsOverlay: NoDataOverlay
                                }}
                                sx={{
                                    '& .clickable-row': { cursor: 'pointer' },
                                    '& .non-clickable-row': { cursor: 'default' },
                                    '& .MuiToolbar-root': { minHeight: '45px !important' },

                                    // MAKE DISABLE OUTLINE IN THE DATAGRID TABLE
                                    '& .MuiDataGrid-cell:focus': {
                                        outline: 'none',
                                    },

                                    '& .MuiDataGrid-row:hover': {
                                        backgroundColor: '#939ba354',
                                    }
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default UserGroup